<template>
  <Dialog title="修改密码" width="560px" :auto-height="true" @close="handlePasswordDialogBeforeClose">
    <div class="content">
      <el-form ref="passwordFormRef" label-width="100px" status-icon :rules="passwordRules" :model="passwordForm">
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="passwordForm.newPassword" type="password" clearable show-password placeholder="请输入新密码" />
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmNewPassword">
          <el-input v-model="passwordForm.confirmNewPassword" type="password" clearable show-password placeholder="请再次输入新密码" />
        </el-form-item>
      </el-form>
    </div>
    <template #footer>
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="updatePasswordSubmit">确定</el-button>
    </template>
  </Dialog>
</template>

<script setup>
import { ref } from 'vue'
import Dialog from '@/components/dialog'
import { putUpdateAccountPassword } from '@/server/domain'
import { ElMessage } from 'element-plus'

const props = defineProps({
  curUserid: String,
})

const passwordForm = ref({
  newPassword: '',
  confirmNewPassword: '',
})
const passwordFormRef = ref()

const passwordRules = {
  newPassword: [
    { required: true, message: '请输入新密码', trigger: 'blur' },
    {
      validator: (rule, value, callback) => {
        const pattern = /^(?=.*[a-zA-Z0-9._~!@#$^&*])[A-Za-z0-9._~!@#$^&*]{6,20}$/
        if (!pattern.test(value)) {
          callback(new Error('请输入包含英文字母大小写、数字和特殊符号(._~!@#$^&*)的 6-20 位组合'))
        } else {
          callback()
        }
      },
      trigger: 'blur',
    },
  ],
  confirmNewPassword: [
    { required: true, message: '请再次输入新密码', trigger: 'blur' },
    {
      validator: (rule, value, callback) => {
        const pattern = /^(?=.*[a-zA-Z0-9._~!@#$^&*])[A-Za-z0-9._~!@#$^&*]{6,20}$/
        if (value !== passwordForm.value.newPassword) {
          callback(new Error('两次新密码输入不一致'))
        } else if (!pattern.test(value)) {
          callback(new Error('请输入包含英文字母大小写、数字和特殊符号(._~!@#$^&*)的 6-20 位组合'))
        } else {
          callback()
        }
      },
      trigger: 'blur',
    },
  ],
}

const emit = defineEmits(['cancel', 'success'])

const cancel = () => {
  emit('cancel')
}

// 修改密码弹窗点击确定按钮
function updatePasswordSubmit() {
  passwordFormRef.value.validate(async (valid, fields) => {
    if (valid) {
      const { data } = await putUpdateAccountPassword({
        userid: props.curUserid,
        newPassword: passwordForm.value.newPassword,
      })
      if (data.code === 200) {
        emit('success')
        ElMessage({ message: data.msg, type: 'success' })
      } else {
        ElMessage({ message: data.msg, type: 'error' })
      }
    } else {
      console.log('error submit!', fields)
    }
  })
}

// 关闭弹窗回调
function handlePasswordDialogBeforeClose() {
  passwordFormRef.value.resetFields()
}
</script>

<style scoped lang="scss"></style>
